export default function createTracker(report, getDiffRouteTime) {
  return {
    loadPage() {
      report({
        eventName: 'load_page',
        eventDescription: '全局埋点'
      });
    },
    clickIndex() {
      report({
        eventName: 'click_index',
        eventDescription: '点击鉴定'
      });
    },
    clickExit1(elVal) {
      report({
        eventName: 'click_exit1',
        eventDescription: '退登',
        eventDataValue: {
          el_val: elVal
        }
      });
    },
    clickJh1() {
      report({
        eventName: 'click_jh1',
        eventDescription: '点击激活'
      });
    },
    clickJh2(status) {
      report({
        eventName: 'click_jh2',
        eventDescription: '点击验证',
        eventDataValue: {
          status: status
        }
      });
    },
    clickExit2(elVal) {
      report({
        eventName: 'click_exit2',
        eventDescription: '退登',
        eventDataValue: {
          el_val: elVal
        }
      });
    },
    createQrc(elVal) {
      report({
        eventName: 'create_qrc',
        eventDescription: '创建分享二维码',
        eventDataValue: {
          el_val: elVal
        }
      });
    },
    /**
     * el_val: 雏风=1，潜龙=2，至尊=3，无双=4，超神=5
     * @param elVal
     */
    clickExit3(elVal) {
      report({
        eventName: 'click_exit3',
        eventDescription: '退登',
        eventDataValue: {
          el_val: elVal
        }
      });
    },
    clickJh3(status) {
      report({
        eventName: 'click_jh3',
        eventDescription: '完成激活',
        eventDataValue: {
          status: status
        }
      });
    },
    clickExit4(elVal) {
      report({
        eventName: 'click_exit4',
        eventDescription: '退登',
        eventDataValue: {
          el_val: elVal
        }
      });
    }
  };
}



// WEBPACK FOOTER //
// ./src/$$tracker/tracker.js